import { JSXConverters } from '@payloadcms/richtext-lexical/react'
import { SerializedTextNode } from '@payloadcms/richtext-lexical/lexical'

export const textConverter: JSXConverters<SerializedTextNode> = {
  text: ({ node }: { node: SerializedTextNode }) => {
    const text = node.text
    const isItalic = node.format & 2
    const isUnderline = node.format & 8
    const isBold = node.format & 1

    let className = ''
    if (isItalic) {
      className += 'font-serif italic '
    }
    if (isUnderline) {
      className += 'underline font-serif '
    }
    if (isBold) {
      className += 'font-semibold '
    }

    if (className) {
      return <span className={className.trim()}>{text}</span>
    }

    return <>{text}</>
  },
}
